import { DataTable } from '../../components/admin/data-table';
import { DateField } from '../../components/admin/date-field';
import { ReferenceField } from '../../components/admin/reference-field';
import { TextField } from '../../components/admin/text-field';
import { ResourcesValue } from '../resources';
import { useCanAccessUsersResource } from '../../auth/useCanAccessUsersResource';
import { UserDisplayNameField } from '../User/UserDisplayNameField';

export const BadgesAwardsList = () => {
  const canAccessUsers = useCanAccessUsersResource();
  const userLink = canAccessUsers ? 'edit' : false;

  return (
    <DataTable
      rowClick={false}
      bulkActionButtons={false}
      resource={ResourcesValue.BADGE_AWARDS}
    >
      <DataTable.Col source="awardedToUserId" disableSort>
        <ReferenceField
          source="awardedToUserId"
          reference={ResourcesValue.USERS}
          link={userLink}
        >
          <UserDisplayNameField />
        </ReferenceField>
      </DataTable.Col>

      <DataTable.Col source="awardedToUnit" disableSort />

      <DataTable.Col source="badgeId" disableSort>
        <ReferenceField source="badgeId" reference={ResourcesValue.BADGES}>
          <TextField source="name" />
        </ReferenceField>
      </DataTable.Col>

      <DataTable.Col source="awardedByUserId" disableSort>
        <ReferenceField
          source="awardedByUserId"
          reference={ResourcesValue.USERS}
          link={userLink}
        >
          <UserDisplayNameField />
        </ReferenceField>
      </DataTable.Col>

      <DataTable.Col source="awardedByUnit" disableSort />

      <DataTable.Col source="awardedOn">
        <DateField
          source="awardedOn"
          showTime
          options={{
            dateStyle: 'medium',
            timeStyle: 'short',
          }}
        />
      </DataTable.Col>
    </DataTable>
  );
};
